// import axios from './BaseService';
import axios from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

const EMPRESA_URL = `${API_URL}/empresa/`;

const getContextHeaders = (extraHeaders = {}) => ({
  cod_org: sessionStorage.getItem('cod_org') || '',
  cod_empresa: sessionStorage.getItem('cod_empresa') || '',
  ...extraHeaders,
});

export async function getEmpresaById(cod_empresa, token) {
  const { data } = await axios.get(`${EMPRESA_URL}${cod_empresa}`, {
    headers: getContextHeaders({ authorization: token }),
  });
  return data; // um único objeto de empresa
}

export async function getEmpresas(page, token) {
  const codOrg = sessionStorage.getItem('cod_org');

  const empresasUrl = `${EMPRESA_URL}?page=${page}&cod_org=${codOrg}`;

  const response = await axios.get(empresasUrl, {
    headers: getContextHeaders({ authorization: token }),
  });
  return response.data;
}

export async function getTodasEmpresas(page = 1, token, search = '') {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const url = `${EMPRESA_URL}/todas?page=${page}${searchParam}`;
  const response = await axios.get(url, {
    headers: getContextHeaders({ authorization: token }),
  });
  return response.data;
}

export async function salvarEmpresa(cod_empresa, novaEmpresa, token) {
  const headers = getContextHeaders({ authorization: token });

  let response;

  if (cod_empresa) {
    response = await axios.patch(`${EMPRESA_URL}${cod_empresa}`, novaEmpresa, {
      headers,
    });
  } else {
    response = await axios.post(`${EMPRESA_URL}`, novaEmpresa, { headers });
  }

  return response.data;
}

export async function excluirEmpresa(cod_empresa, token) {
  const response = await axios.delete(`${EMPRESA_URL}${cod_empresa}`, {
    headers: getContextHeaders({ authorization: token }),
  });
  return response.data;
}

export async function uploadCertificadoEmpresa(cod_empresa, certificado, token) {
  const url = `${EMPRESA_URL}empresa/${cod_empresa}/certificado`;
  const formData = new FormData();
  formData.append('certificado', certificado);

  const response = await axios.post(url, formData, {
    headers: getContextHeaders({
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    }),
  });

  return response.data;
}

export async function setSituacaoEmpresa(cod_empresa, situacao, motivo, token) {
  const body = { situacao, motivo }; // motivo é opcional
  const url = `${EMPRESA_URL}${cod_empresa}/situacao`;
  const response = await axios.patch(url, body, {
    headers: getContextHeaders({ authorization: token }),
  });
  return response.data; // { ok, changed, de, para, cod_org, cod_empresa }
}

export async function getEmpresasByOrg(cod_org) {
  const response = await axios.get(`${EMPRESA_URL}org/${cod_org}/public`, {
    headers: getContextHeaders(),
  });
  return response.data; // array de empresas
}

export async function getEmpresasAutocomplete(search, page, token, cod_org = null) {
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const orgParam = cod_org ? `&cod_org=${encodeURIComponent(cod_org)}` : '';
  const url = `${EMPRESA_URL}/todas?page=${page}${searchParam}${orgParam}`;

  const response = await axios.get(url, {
    headers: getContextHeaders({ authorization: token }),
  });

  // O CustomLookup espera um array em response.rows ou response.data
  return response.data;
}
